
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth";
import { useSaveRefundRequest } from "./useSaveRefundRequest";

export const usePreviewData = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [demoRequest, setDemoRequest] = useState<any>(null);
  const { saveRequestToDatabase, isSaving } = useSaveRefundRequest();
  const hasSavedRef = useRef(false);
  const hasLoadedDemoRef = useRef(false);

  useEffect(() => {
    // If user is logged in and there's demo data, save it to their account
    if (user && !hasSavedRef.current) {
      const demoData = sessionStorage.getItem('demoRefundRequest');
      if (demoData) {
        hasSavedRef.current = true; // Prevent multiple saves
        try {
          saveRequestToDatabase(JSON.parse(demoData))
            .then((conversationId) => {
              // Clear demo data immediately after successful save
              sessionStorage.removeItem('demoRefundRequest');
              // Navigate to the new conversation
              if (conversationId) {
                navigate(`/conversation/${conversationId}`);
              }
            })
            .catch(error => {
              console.error("Error saving demo request:", error);
              hasSavedRef.current = false; // Reset flag if save failed
            });
        } catch (error) {
          console.error("Error parsing demo data:", error);
          sessionStorage.removeItem('demoRefundRequest');
          hasSavedRef.current = false;
        }
      }
    } else if (!user && !hasLoadedDemoRef.current) {
      // For non-authenticated users, just show the preview
      const storedRequest = sessionStorage.getItem('demoRefundRequest');
      if (storedRequest) {
        hasLoadedDemoRef.current = true; // Prevent multiple loads
        try {
          setDemoRequest(JSON.parse(storedRequest));
        } catch (error) {
          console.error("Error parsing demo data:", error);
          navigate('/refund');
        }
      } else {
        navigate('/refund');
      }
    }
  }, [user, navigate, saveRequestToDatabase]);

  const handleSignUpAndSave = () => {
    navigate("/auth", { 
      state: { 
        from: { pathname: "/preview" },
        showSignUp: true,
        defaultTab: "signup"
      } 
    });
  };

  return {
    demoRequest,
    isSaving,
    handleSignUpAndSave
  };
};
